<div>
    <p>Autorizzi a mantenere attiva la sessione di lavoro con il Ministero della Giustizia per operazioni eseguite in background (es. aggiornamento massivo)?</p>
    <div class="row btn-group-row">
        <div class="col-sm-4 col-xs-6">
            <button type="button" aria-label="Non acconsento" (click)="onAction(false)" class="btn btn-danger btn-block">Non acconsento</button>
        </div>
        <div class="col-sm-4 hidden-xs"></div>
        <div class="col-sm-4 col-xs-6">
            <button type="button" aria-label="Acconsento" (click)="onAction(true)" class="btn btn-primary btn-block">Acconsento</button>
        </div>
    </div>
</div>

